"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
;
;
;
var EPccUploadTaskStatus;
(function (EPccUploadTaskStatus) {
    EPccUploadTaskStatus["PENDING"] = "PENDING";
    EPccUploadTaskStatus["IN_PROGRESS"] = "IN_PROGRESS";
    EPccUploadTaskStatus["READY"] = "READY";
    EPccUploadTaskStatus["FAILED"] = "FAILED";
    EPccUploadTaskStatus["COMPLETED"] = "COMPLETED";
    EPccUploadTaskStatus["CANCELED"] = "CANCELED";
})(EPccUploadTaskStatus = exports.EPccUploadTaskStatus || (exports.EPccUploadTaskStatus = {}));
;
class ParsedDepositHtml {
}
exports.ParsedDepositHtml = ParsedDepositHtml;
class pccDepositPaymentDistribution {
}
exports.pccDepositPaymentDistribution = pccDepositPaymentDistribution;
var EPccDepositError;
(function (EPccDepositError) {
    EPccDepositError["PAYMENT_TOTAL"] = "PAYMENT_TOTAL";
    EPccDepositError["DEPOSIT_TOTAL"] = "DEPOSIT_TOTAL";
    EPccDepositError["RESERVES"] = "RESERVES";
    EPccDepositError["MISSING_RESIDENT"] = "MISSING_RESIDENT";
    EPccDepositError["MISSING_TED"] = "MISSING_TED";
    EPccDepositError["MISSING_PAYER"] = "MISSING_PAYER";
    EPccDepositError["MISSING_TED_DATE"] = "MISSING_TED_DATE";
    EPccDepositError["MISSING_APPLIEDTO_AMOUNT"] = "MISSING_APPLIEDTO_AMOUNT";
    EPccDepositError["MISSING_APPLIEDTO"] = "MISSING_APPLIEDTO";
})(EPccDepositError = exports.EPccDepositError || (exports.EPccDepositError = {}));
var EResidentMatchType;
(function (EResidentMatchType) {
    EResidentMatchType["FULL"] = "FULL";
    EResidentMatchType["PARTIAL"] = "PARTIAL";
})(EResidentMatchType = exports.EResidentMatchType || (exports.EResidentMatchType = {}));
;
var ManualPccIntegrationType;
(function (ManualPccIntegrationType) {
    ManualPccIntegrationType["IMPORT_REPORT"] = "importReport";
    ManualPccIntegrationType["PUSH_DEPOSIT"] = "pushDeposit";
})(ManualPccIntegrationType = exports.ManualPccIntegrationType || (exports.ManualPccIntegrationType = {}));
;
